var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"disabled":_vm.disabled === 'true' || _vm.disabled === true,"prefix":_vm.prefix,"value":_vm.value,"suffix":_vm.suffix,"label":_vm.name,"error-messages":_vm.validationError},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }